"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteProvider = void 0;
const BaseDataProvider_1 = require("./BaseDataProvider");
class InviteProvider extends BaseDataProvider_1.BaseDataProvider {
    constructor() {
        // INVITES
        super(...arguments);
        this.invite = (id) => {
            return this.docPromise(this.refs.inviteDocument(id));
        };
        this.invitesForUserStream = (userId) => {
            const query = this.refs.inviteCollection().where('userId', '==', userId);
            return this.collectionDataStream(query, false);
        };
        this.invitesForAssignment = (assignmentId) => {
            const query = this.refs.inviteCollection().where('assignmentId', '==', assignmentId);
            return this.collectionPromise(query);
        };
    }
}
exports.InviteProvider = InviteProvider;
//# sourceMappingURL=InviteProvider.js.map